<template>
    <div>
        <div class="back">
            <a href="/function"><img src="/static/tutorial/back.png" alt=""></a>
        </div>
        <div class="introduction">

            <h1>{{this.EventBus.getText("shape_title")}}</h1>
            <p>{{this.EventBus.getText("shape_title_ex1")}}<br>{{this.EventBus.getText("shape_title_ex2")}}<br>{{this.EventBus.getText("shape_title_ex3")}}</p>
            <img :src=shape_img alt="">
        </div>
        <div class="container_wrap">
            <div class="container">
                <div class="item_wrap">
                    <div class="item item2">
                        <h2>{{this.EventBus.getText("shape_3Dshape")}}</h2>
                        <hr width=50%>
                        <p>{{this.EventBus.getText("shape_3Dshape_ex")}}</p>
                    </div>
                </div>
                
                <div class="item item1" v-for="data in shape1" v-bind:key="data.index">
                    <div v-if="data.index <=8">
                        <img :src=data.img  alt="">
                        <h2>{{data.subject}}</h2>
                        <p>{{data.explain}}</p>
                    </div>
                </div>
                <div class="item_wrap">
                    <div class="item item3">
                        <h2>{{this.EventBus.getText("shape_2Dshape")}}</h2>
                        <hr width=50%>
                        <p>{{this.EventBus.getText("shape_2Dshape_ex")}}</p>
                    </div>
                </div>
                
                <div class="item item1" v-for="data in shape2" v-bind:key="data.index">
                    <div v-if="data.index >8">
                        <img :src=data.img  alt="">
                        <h2>{{data.subject}}</h2>
                        <p>{{data.explain}}</p>
                    </div>
                </div>
            </div>
        </div>
        <js/>

    </div>
</template>
<script>
import Shape from '../../assets/language/shape.json'
export default {
    beforeCreate(){
        this.EventBus.loadLanguage(Shape);
    },
    data(){
        return{
            shape_img: this.EventBus.getText("shape_img"),
            shape1: [
                {
                    index: 1,
                    img : '/static/tutorial/functions/shape/12. 도형/1. 상자.png',
                    subject: this.EventBus.getText("shape_cube"),
                    explain: this.EventBus.getText("shape_cube_ex")
                },
                {
                    index: 2,
                    img :  '/static/tutorial/functions/shape/12. 도형/2. 원형구.png',
                    subject: this.EventBus.getText("shape_sphere"),
                    explain: this.EventBus.getText("shape_sphere_ex")
                },
                {
                    index: 3,
                    img :  '/static/tutorial/functions/shape/12. 도형/3. 원기둥.png',
                    subject: this.EventBus.getText("shape_cylinder"),
                    explain: this.EventBus.getText("shape_cylinder_ex")
                },
                {
                    index: 4,
                    img :  '/static/tutorial/functions/shape/12. 도형/4. 다각뿔.png',
                    subject: this.EventBus.getText("shape_pyramid"),
                    explain: this.EventBus.getText("shape_pyramid_ex")
                },
                {
                    index: 5,
                    img :  '/static/tutorial/functions/shape/12. 도형/5. 원뿔.png',
                    subject: this.EventBus.getText("shape_cone"),
                    explain: this.EventBus.getText("shape_cone_ex")
                },
                {
                    index: 6,
                    img :  '/static/tutorial/functions/shape/12. 도형/6. 반구.png',
                    subject: this.EventBus.getText("shape_hemi"),
                    explain: this.EventBus.getText("shape_hemi_ex")
                },
                {
                    index: 7,
                    img :  '/static/tutorial/functions/shape/12. 도형/7. 도넛.png',
                    subject: this.EventBus.getText("shape_torus"),
                    explain: this.EventBus.getText("shape_torus_ex")
                },
                {
                    index: 8,
                    img :  '/static/tutorial/functions/shape/12. 도형/8. 다각기둥.png',
                    subject: this.EventBus.getText("shape_poly"),
                    explain: this.EventBus.getText("shape_poly_ex")
                },
            ],
            shape2: [   
                {
                    index: 9,
                    img :  '/static/tutorial/functions/shape/12. 도형/9. 글자.png',
                    subject: this.EventBus.getText("shape_text"),
                    explain: this.EventBus.getText("shape_text_ex")
                },
                {
                    index: 10,
                    img :  '/static/tutorial/functions/shape/12. 도형/10. 사각형.png',
                    subject: this.EventBus.getText("shape_rec"),
                    explain: this.EventBus.getText("shape_rec_ex")
                },
                {
                    index: 11,
                    img : '/static/tutorial/functions/shape/12. 도형/11. 원형.png',
                    subject: this.EventBus.getText("shape_circle"),
                    explain: this.EventBus.getText("shape_circle_ex")
                },
                {
                    index: 12,
                    img :  '/static/tutorial/functions/shape/12. 도형/12. 타원형.png',
                    subject: this.EventBus.getText("shape_elli"),
                    explain:this.EventBus.getText("shape_elli_ex")
                },
                {
                    index: 13,
                    img :  '/static/tutorial/functions/shape/12. 도형/13. 다각형.png',
                    subject: this.EventBus.getText("shape_polygon"),
                    explain: this.EventBus.getText("shape_polygon_ex")
                },
                {
                    index: 14,
                    img :  '/static/tutorial/functions/shape/12. 도형/14. 톱니.png',
                    subject: this.EventBus.getText("shape_gear"),
                    explain: this.EventBus.getText("shape_gear_ex")
                },
                {
                    index: 15,
                    img :  '/static/tutorial/functions/shape/12. 도형/15. 직선.png',
                    subject: this.EventBus.getText("shape_line"),
                    explain: this.EventBus.getText("shape_line_ex") 
                },
                {
                    index: 16,
                    img :  '/static/tutorial/functions/shape/12. 도형/16. 곡선.png',
                    subject: this.EventBus.getText("shape_curve"),
                    explain: this.EventBus.getText("shape_curve_ex")
                },
            ]
            
        }
    },
}
</script>

<style scoped>
    .introduction{
        margin: 7vw auto;
        /* height: 1080px; */
        /* background-color: blue; */
        text-align: center;
    }

    h1{
        font-weight: 700;
        color: #141414;
        font-size: 30px;
    }

    h2{
        font-weight: 700;
        color: #5E5E5E;
        font-size: 20px;
        letter-spacing: 0.1rem;
        
    }


    .introduction img{
        width: 900px;
        margin: 1vw;
        box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.05);
    }

    .back img{
        margin-left: 100px;
        width: 35px;
        box-shadow: none;
        display: flex;
        position: fixed;
    }
    p{
        font-size: 16px;
        letter-spacing: 0.1rem;
        
    }

    .container_wrap{
        background-color: #F8F6F6;
    }

    .container{
        display: flex;
        flex-wrap: wrap;
        /* justify-content: space-evenly; */
        align-content: space-evenly;
        align-items: center;
        padding-top: 100px;
        padding-left: 100px;

    }

    .item {
        width: 280px;
        height: 280px;
        border-radius: 70px;
        padding:  70px 50px;
        margin-bottom: 60px;
        margin-right: 40px;
    }

    .item p{
        font-size: 15px;
        line-height: 1.2rem;
        letter-spacing: 0.05rem;
        color: white;
    }

    .item h2{
        font-size: 30px;
        margin: 5;
        color: white;
    }

    .item img{
        width: 60px;
        margin: 5px 0px 20px 0px;
    }
    .item hr{
        border: 2px solid white;
        margin-left: 0;
    }

    .item_wrap{
        width: 100vw;
    }
    .item1{
        background-color: white;
        padding: 40px 45px;
    }
    .item1 h2 {
        color: black;
        font-size: 20px;
        margin-bottom: 15px;
    }
    .item1 p{
        color: black;
    }
    .item2{
        background-color: #645DC7;
    }
    .item3{
        background-color: #FB6D37;
    }
    
</style>


// WEBPACK FOOTER //
// src/pages/tutorial_functions/function_shape.vue